import React, { useRef, useState } from "react";
import { ArrowRight, Play, Award, Clock } from "lucide-react";
import { JOTFORM_URL } from "../constants";
import { useSite } from "../contexts/SiteContext";
import { resolveAssetUrl } from "../lib/api";

const Stat = ({ value, label }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
    <span className="h-display" style={{ fontSize: 38, lineHeight: 1 }}>{value}</span>
    <span style={{ fontSize: 13, color: "#5F5A72", fontWeight: 500 }}>{label}</span>
  </div>
);

const Hero = () => {
  const { content } = useSite();
  const hero = content.hero || {};
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const videoSrc = resolveAssetUrl(hero.videoUrl);
  const posterSrc = resolveAssetUrl(hero.videoThumbnail);

  const handlePlay = () => {
    setPlaying(true);
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.muted = false;
        videoRef.current.currentTime = 0;
        videoRef.current.play().catch(() => {});
      }
    }, 60);
  };

  return (
    <section id="inicio" style={{ padding: "60px 24px 100px" }}>
      <div
        style={{ maxWidth: 1240, margin: "0 auto", display: "grid", gridTemplateColumns: "1.05fr 1fr", gap: 56, alignItems: "center" }}
        className="hero-grid"
      >
        <div className="fade-in">
          <span className="pill" style={{ marginBottom: 24 }}>
            <span style={{ width: 6, height: 6, borderRadius: 99, background: "#FF4F1A" }} /> {hero.pillText}
          </span>

          <h1 className="h-display" style={{ fontSize: "clamp(40px, 6vw, 78px)", margin: "18px 0 22px" }}>
            {hero.titleLine1}<br />
            {hero.titleLine2Prefix}<span className="text-grad-purple">{hero.titleLine2Highlight}</span>
            <br />
            <span className="text-grad-purple">{hero.titleLine3Highlight}</span>
            <br />{hero.titleLine4}
          </h1>

          <p style={{ fontSize: 17, color: "#5F5A72", lineHeight: 1.55, maxWidth: 520, marginBottom: 28 }}>
            {hero.subtitle}
          </p>

          <a href={hero.ctaHref || "#metodo"} className="btn-dark" style={{ marginBottom: 44 }}>
            {hero.ctaText} <ArrowRight size={16} />
          </a>

          <div style={{ display: "flex", gap: 44, flexWrap: "wrap" }}>
            <Stat value={hero.stat1Value} label={hero.stat1Label} />
            <Stat value={hero.stat2Value} label={hero.stat2Label} />
            <Stat value={hero.stat3Value} label={hero.stat3Label} />
          </div>
        </div>

        <div className="fade-in" style={{ position: "relative" }}>
          <div className="hero-video-wrap img-zoom-wrap">
            {!playing && (
              <>
                <img src={posterSrc} alt="" className="img-zoom" />
                <button className="play-btn" onClick={handlePlay} aria-label="Reproducir vídeo">
                  <Play size={28} color="#1A1352" fill="#1A1352" />
                </button>
              </>
            )}
            {playing && (
              <video
                ref={videoRef}
                src={videoSrc}
                controls
                playsInline
                preload="auto"
                style={{ width: "100%", height: "100%", objectFit: "contain", background: "#000" }}
              />
            )}
          </div>

          <div className="chip-card hero-chip-top" style={{ position: "absolute", top: -64, left: 18 }}>
            <span style={{ width: 28, height: 28, borderRadius: 8, background: "rgba(84,70,234,0.12)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
              <Award size={15} color="#5446EA" />
            </span>
            <div style={{ lineHeight: 1.2 }}>
              <div style={{ fontSize: 13 }}>{hero.chip1Title}</div>
              <div style={{ fontSize: 11, color: "#5F5A72", fontWeight: 500 }}>{hero.chip1Subtitle}</div>
            </div>
          </div>

          <a href={JOTFORM_URL} target="_blank" rel="noopener noreferrer" className="chip-card hero-chip-bottom" style={{ position: "absolute", bottom: -64, right: 18, textDecoration: "none" }}>
            <span style={{ width: 28, height: 28, borderRadius: 8, background: "rgba(255,79,26,0.14)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
              <Clock size={15} color="#FF4F1A" />
            </span>
            <div style={{ lineHeight: 1.2 }}>
              <div style={{ fontSize: 13 }}>{hero.chip2Title}</div>
              <div style={{ fontSize: 11, color: "#5F5A72", fontWeight: 500 }}>{hero.chip2Subtitle}</div>
            </div>
          </a>
        </div>
      </div>

      <style>{`@media (max-width: 900px){.hero-grid{grid-template-columns:1fr !important;gap:30px !important;}}`}</style>
    </section>
  );
};

export default Hero;
